import api from "@/api";
import store from "@/vuex/store";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
class MultilingualService {
  $api = api;
  $store = store;
  $routes = null;
  $progress = nprogress;
  appId = "";
  appToken = "";
  allApplangaKeys = null;
  defaultCulture = "en";
  defaultTranslationKeys = null;
  languageCulture = "";
  isCallbackDefined = false;
  strings = "";
  callbackFunction;

  constructor(routes, studyLanguageId) {
    const languageId = "ca0af64b-9a40-11e9-8a9c-12046093208c";
    this.loadAppLangaKeys(routes, studyLanguageId || languageId);
  }

  async loadAppLangaKeys(route, language) {
    this.$routes = route;
    const languageId = "ca0af64b-9a40-11e9-8a9c-12046093208c";
    if (this.$routes && this.$routes.params) {
      try {
        const translations = await this.$api.getLanguageTranslateApplanga(this.$routes.params.studyId, language || languageId);
        this.allApplangaKeys = !!translations && !!translations.body && Object.keys(translations.body).length > 0 ? translations.body : null;

        if (this.allApplangaKeys && Object.keys(this.allApplangaKeys).includes(this.defaultCulture)) {
          this.defaultTranslationKeys = this.allApplangaKeys;
        }
      } catch (e) {
        this.allApplangaKeys = null;
      }
    } else {
      this.allApplangaKeys = null;
    }
  }

  getParticipantsWebTranslation(studyId, studyVersionId, languageId) {
    return new Promise((resolve, reject) => {
      this.$api
        .getParticipantWebTranslation(studyId, studyVersionId, languageId)
        .then(response => {
          this.allApplangaKeys = response.data;
          this.$store.dispatch("setParticipantsPortalLanguages", response.data);
          resolve();
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  i18n(key, lang) {
    if (this.$store.getters.getParticipantsPortalLanguages) {
      this.allApplangaKeys = this.$store.getters.getParticipantsPortalLanguages;
    }
    if (this.$store.getters.getParticipantsPortalLanguageTranslation) {
      this.strings = this.$store.getters.getParticipantsPortalLanguageTranslation;
      return this.strings[key] ? this.strings[key] : false;
    }
    if (lang && lang.toLowerCase() !== this.defaultCulture) {
      this.languageCulture = lang;
    }
    if (this.languageCulture !== "" && this.languageCulture !== undefined && this.languageCulture !== "EN" && this.allApplangaKeys !== null) {
      const entries = this.allApplangaKeys[this.languageCulture]["main"]["entries"];
      return entries[key] ? entries[key].v : "";
    }
    return false;
  }

  i18nTranslate(key, lang) {
    if (this.$store.getters.getCSSRActivityLanguages) {
      this.allApplangaKeys = this.$store.getters.getCSSRActivityLanguages;
    }
    if (lang && lang.toLowerCase() !== this.defaultCulture) {
      this.languageCulture = lang;
    }
    if (this.languageCulture !== "" && this.languageCulture !== undefined && this.languageCulture !== "EN" && this.allApplangaKeys !== null && Object.keys(this.allApplangaKeys).length != 0) {
      const entries = this.allApplangaKeys[this.languageCulture] ? this.allApplangaKeys[this.languageCulture]["main"]["entries"] : this.allApplangaKeys[this.languageCulture.toLowerCase()] ? this.allApplangaKeys[this.languageCulture.toLowerCase()]["main"]["entries"] : "";
      return entries[key] ? entries[key].v : false;
    }
    return false;
  }

  getCSSRTranslation(studyId, languageId) {
    this.$api.getLanguageTranslateApplanga(studyId, languageId).then(response => {
      const updatedTranslations = this.emptyTranslationHandled(response.data);
      this.allApplangaKeys = updatedTranslations;
      this.$store.dispatch("setCSSRActivityLanguages", updatedTranslations);
    });
  }

  emptyTranslationHandled(object) {
    if (object) {
      Object.entries(object).forEach(([k, v]) => {
        if (v && typeof v === "object") {
          this.emptyTranslationHandled(v);
        }
        if ((v && typeof v === "object" && !Object.keys(v).length) || v === {}) {
          if (Array.isArray(object)) {
            object.splice(k, 1);
          } else {
            delete object[k];
          }
        }
      });
      return object;
    }
  }

  getAllQuestionTypeConversion(questions, responses, lang, revisionId = null) {
    const progress = this.$progress;
    progress.start();
    const language = lang == "EN" ? lang.toLowerCase() : lang;
    return new Promise((resolve, reject) => {
      if (Array.isArray(questions) && this.allApplangaKeys !== null) {
        this.languageCulture = language.includes("-") ? language : language.toLowerCase();

        const isLanguageKeyExists = Object.keys(this.allApplangaKeys).includes(this.languageCulture);
        if (isLanguageKeyExists && this.languageCulture !== this.defaultCulture) {
          const allEntires = this.allApplangaKeys[this.languageCulture]["main"]["entries"];

          this.getQuestionTypeConversion(questions, allEntires, responses, revisionId).then(
            function(result) {
              progress.done();
              resolve(result);
            },
            err => {
              progress.done();
              reject({ response: responses, questions: questions, error: err });
            }
          );
        } else {
          if (this.allApplangaKeys) {
            const allEntires = this.allApplangaKeys[this.defaultCulture]["main"]["entries"];

            this.getQuestionTypeConversion(questions, allEntires, responses, revisionId).then(
              function(result) {
                progress.done();
                resolve(result);
              },
              err => {
                progress.done();
                reject({
                  response: responses,
                  questions: questions,
                  error: err
                });
              }
            );
          }
        }
      } else {
        progress.done();
        responses.forEach((innerItem, index) => {
          questions.forEach(item => {
            if (innerItem.questionId == item.id) {
              responses[index].questionBody = item.formattedBody === undefined ? (item.questionBody ? item.questionBody : item.formattedTitle) : item.formattedBody;
              responses[index].displayQuestionText = item.formattedBody === undefined ? (item.questionBody ? item.questionBody : item.formattedTitle) : item.formattedBody;
              responses[index].questionInformation = item.formattedInformation === undefined ? (item.questionInformation ? item.questionInformation : item.formattedInformation) : item.formattedInformation;
            }
          });
        });
        reject({
          response: responses,
          questions: questions,
          error: "Unable to get the conversion."
        });
      }
    });
  }

  getQuestionTypeConversion(questions, entries, responses, revisionId) {
    return new Promise((resolve, reject) => {
      try {
        const disallowQuestionTypes = ["SurveyCompletion"];
        const allDefaultEntries = this.defaultTranslationKeys[this.defaultCulture]["main"]["entries"];
        questions.forEach((question, i) => {
          if (disallowQuestionTypes.indexOf(question.type) == -1) {
            const activityId = question.activityId || question.surveyId;
            const revisedID = revisionId || activityId;
            let questionBody = "";
            let questionFormattedBody = "";
            let questionInformation = "";
            const responseIndex = responses.findIndex(response => response.questionId == question.id);
            const questionAppLangaKey = question.id + "_body";
            const questionFormatBodyKey = question.id + "_formattedBody";
            const questionInformationKey = question.id + "_formattedInformation";
            const reviseQuestionALKey = `${revisedID}_${questionAppLangaKey}`;
            const reviseQuestionFormatBodyKey = `${revisedID}_${questionFormatBodyKey}`;
            const revisequestionInformationKey = `${revisedID}_${questionInformationKey}`;
            const isQuestionIdExists = entries.hasOwnProperty(questionAppLangaKey) || entries.hasOwnProperty(reviseQuestionALKey);
            const isDefaultQuesIdExists = allDefaultEntries.hasOwnProperty(questionAppLangaKey) || allDefaultEntries.hasOwnProperty(reviseQuestionALKey);
            const isDefaultQuestionInformationIdExists = allDefaultEntries.hasOwnProperty(questionInformationKey) || allDefaultEntries.hasOwnProperty(revisequestionInformationKey);

            if (isQuestionIdExists) {
              questionBody = entries[questionAppLangaKey] ? entries[questionAppLangaKey].v : entries[reviseQuestionALKey].v;
              if (entries.hasOwnProperty(questionInformationKey)) {
                questionInformation = entries[questionInformationKey].v;
              } else if (entries.hasOwnProperty(revisequestionInformationKey)) {
                questionInformation = entries[revisequestionInformationKey].v;
              }
              if (entries.hasOwnProperty(questionFormatBodyKey)) {
                questionFormattedBody = entries[questionFormatBodyKey].v;
              } else if (entries.hasOwnProperty(reviseQuestionFormatBodyKey)) {
                questionFormattedBody = entries[reviseQuestionFormatBodyKey].v;
              } else {
                questionFormattedBody = allDefaultEntries[questionFormatBodyKey] ? allDefaultEntries[questionFormatBodyKey].v : allDefaultEntries[reviseQuestionFormatBodyKey].v;
              }
            } else if (isDefaultQuesIdExists) {
              questionBody = allDefaultEntries[questionAppLangaKey] ? allDefaultEntries[questionAppLangaKey].v : allDefaultEntries[reviseQuestionALKey].v;
              questionFormattedBody = allDefaultEntries[questionFormatBodyKey] ? allDefaultEntries[questionFormatBodyKey].v : allDefaultEntries[reviseQuestionFormatBodyKey].v;
            } else if (isDefaultQuestionInformationIdExists) {
              if (entries.hasOwnProperty(questionInformationKey)) {
                questionInformation = entries[questionInformationKey].v;
              } else if (entries.hasOwnProperty(revisequestionInformationKey)) {
                questionInformation = entries[revisequestionInformationKey].v;
              }
            } else {
              questionBody = question.body;
              questionFormattedBody = question.formattedBody;
              questionInformation = question.formattedInformation;
            }

            if (responseIndex > -1) {
              switch (question.type) {
                case "MultiChoice": {
                  const options = question.options.map(option => {
                    const applangaKey = question.id + "_options_" + option.id + "_label";
                    const reviseOptionKey = `${revisedID}_${question.id}_options_${option.id}_body`;
                    const translatedOption = {
                      id: option.id,
                      body: option.body,
                      score: option.score,
                      formattedBody: option.formattedBody
                    };

                    if (entries.hasOwnProperty(applangaKey) || entries.hasOwnProperty(reviseOptionKey)) {
                      translatedOption.body = entries[applangaKey] ? entries[applangaKey].v : entries[reviseOptionKey].v;
                    }
                    return translatedOption;
                  });

                  let selectedOptions = [];
                  let displayAnswers = [];
                  if (responses[responseIndex] && !!responses[responseIndex].optionId) {
                    selectedOptions = responses[responseIndex].optionId.split(",");
                    displayAnswers = selectedOptions.reduce((displayAnswerTextArray, each) => {
                      const answer = options.find(opt => opt.id == each);
                      if (answer) {
                        displayAnswerTextArray.push(answer.body);
                      }
                      return displayAnswerTextArray;
                    }, []);
                  }

                  if (this.languageCulture == "en") {
                    responses[responseIndex]["questionBody"] = questionFormattedBody;
                    responses[responseIndex]["answerText"] = displayAnswers ? displayAnswers.join(",") : "";
                  }
                  responses[responseIndex]["options"] = options;
                  responses[responseIndex]["displayQuestionText"] = questionFormattedBody;
                  responses[responseIndex]["displayAnswerText"] = displayAnswers ? displayAnswers.join(",") : "";
                  questions[i]["body"] = questionBody;
                  questions[i]["formattedBody"] = questionFormattedBody;
                  questions[i]["options"] = options;
                  break;
                }
                case "Boolean": {
                  const options = question.options.map(option => {
                    const applangaKey = question.id + "_options_" + option.id + "_label";
                    const revisedOptionKey = `${revisedID}_${question.id}_options_${option.id}_label`;
                    const revisedOptionKeyBody = `${revisedID}_${question.id}_options_${option.id}_body`;
                    if (entries.hasOwnProperty(applangaKey) || entries.hasOwnProperty(revisedOptionKey)) {
                      return {
                        id: option.id,
                        body: entries[applangaKey] ? entries[applangaKey].v : entries[revisedOptionKey].v,
                        score: option.score
                      };
                    } else if (entries.hasOwnProperty(revisedOptionKeyBody)){
                      return {
                        id: option.id,
                        body: entries[revisedOptionKeyBody] ? entries[revisedOptionKeyBody].v : option.body,
                        score: option.score
                      };
                    } else {
                      return { id: option.id, body: option.body, score: option.score };
                    }
                  });
                  if (this.languageCulture == "en") {
                    responses[responseIndex]["questionBody"] = questionFormattedBody;
                    responses[responseIndex]["answerText"] = options.reduce((arrayOld, each) => {
                      let array = arrayOld;
                      if (each.id == responses[responseIndex]["optionId"]) {
                        array = each.body;
                      }
                      return array;
                    }, "");
                  }
                  responses[responseIndex]["displayQuestionText"] = questionFormattedBody;
                  responses[responseIndex]["options"] = options;
                  responses[responseIndex]["displayAnswerText"] = options.reduce((arrayOld, each) => {
                    let array = arrayOld;
                    if (each.id == responses[responseIndex]["optionId"]) {
                      array = each.body;
                    }
                    return array;
                  }, "");

                  questions[i]["body"] = questionBody;
                  questions[i]["formattedBody"] = questionFormattedBody;
                  questions[i]["options"] = options;
                  break;
                }
                case "CustomScale": {
                  const options = question.labels.map((option, index) => {
                    const applangaKey = question.id + "_labels_" + index + "_label";
                    const revisedOptionKey = `${revisedID}_${question.id}_labels_${index}_label`;

                    if (entries.hasOwnProperty(applangaKey) || entries.hasOwnProperty(revisedOptionKey)) {
                      return entries[applangaKey] ? entries[applangaKey].v : entries[revisedOptionKey].v;
                    } else {
                      return option;
                    }
                  });
                  const labelIndex = question.labels.indexOf(responses[responseIndex]["answerText"]);
                  if (this.languageCulture == "en") {
                    responses[responseIndex]["questionBody"] = questionFormattedBody;
                    responses[responseIndex]["answerText"] = options[labelIndex] ? options[labelIndex] : responses[responseIndex]["answerText"];
                  }
                  responses[responseIndex]["displayAnswerText"] = options[labelIndex] ? options[labelIndex] : responses[responseIndex]["answerText"];
                  responses[responseIndex]["labels"] = options;
                  responses[responseIndex]["displayQuestionText"] = questionFormattedBody;

                  questions[i]["body"] = questionBody;
                  questions[i]["formattedBody"] = questionFormattedBody;
                  questions[i]["labels"] = options;
                  break;
                }
                case "DropDown": {
                  const options = question.options.map(option => {
                    const applangaKey = question.id + "_options_" + option.id + "_label";
                    const reviseOptionKey = `${revisedID}_${question.id}_options_${option.id}_body`;
                    const translatedOption = {
                      id: option.id,
                      body: option.body
                    };

                    if (entries.hasOwnProperty(applangaKey) || entries.hasOwnProperty(reviseOptionKey)) {
                      translatedOption.body = entries[applangaKey] ? entries[applangaKey].v : entries[reviseOptionKey].v;
                    }
                    return translatedOption;
                  });

                  if (this.languageCulture == "en") {
                    responses[responseIndex]["questionBody"] = questionFormattedBody;
                    responses[responseIndex]["answerText"] = options.reduce((arrayOld, each) => {
                      let array = arrayOld;
                      if (each.id == responses[responseIndex]["optionId"]) {
                        array = each.body;
                      }
                      return array;
                    }, "");
                  }
                  responses[responseIndex]["displayAnswerText"] = options.reduce((arrayOld, each) => {
                    let array = arrayOld;
                    if (each.id == responses[responseIndex]["optionId"]) {
                      array = each.body;
                    }
                    return array;
                  }, "");
                  responses[responseIndex]["options"] = [];
                  responses[responseIndex]["displayQuestionText"] = questionFormattedBody;
                  questions[i]["body"] = questionBody;
                  questions[i]["formattedBody"] = questionFormattedBody;
                  questions[i]["options"] = options;
                  break;
                }
                case "SurveyInstruction": {
                  responses[responseIndex]["questionBody"] = questionFormattedBody;
                  responses[responseIndex]["displayQuestionText"] = questionFormattedBody;
                  responses[responseIndex]["questionInformation"] = questionInformation;
                  break;
                }
                default:
                  if (this.languageCulture == "en") {
                    responses[responseIndex]["questionBody"] = questionFormattedBody;
                  }
                  responses[responseIndex]["options"] = [];
                  responses[responseIndex]["displayAnswerText"] = responses[responseIndex]["displayAnswerText"] !== undefined ? responses[responseIndex]["displayAnswerText"] : responses[responseIndex]["answerText"];
                  responses[responseIndex]["displayQuestionText"] = questionFormattedBody;
                  questions[i]["body"] = questionBody;
                  questions[i]["formattedBody"] = questionFormattedBody;
                  questions[i]["options"] = [];
                  break;
              }
            }
          }
        });
        resolve({ response: responses, questions: questions });
      } catch (err) {
        reject(err);
      }
    });
  }
}

export default MultilingualService;
